import React from "react";
import { Link } from "react-router-dom";
import { siteInfo } from "../data/siteInfo";
import { FAQData } from "../data/faqs";
import "../css/Faq.css";

export default function Faq() {
  return (
    <div className="faq-layout">
      <div className="section-heading">
        <p className="eyebrow">A LITTLE HELP BEFORE THE FUN</p>
        <h2>
          Good questions.
          <br />
          Happy answers.
        </h2>
        <p>
          Planning a visit or a celebration? Start here, or get in touch and
          we’ll help you find your way.
        </p>
        <a className="text-link" href={siteInfo.phoneHref}>
          Call {siteInfo.phone}
        </a>
        <Link className="text-link" to="/book">
          Ask about a party
        </Link>
      </div>
      <div className="faq-container">
        {FAQData.map((faq, index) => (
          <details className="faq-item" key={faq.question}>
            <summary id={"faq-question-" + index}>
              {faq.question}
              <span aria-hidden="true">+</span>
            </summary>
            <div className="faq-answer">
              <p>{faq.answer}</p>
              {faq.question.includes("arriving") && (
                <a
                  className="text-link"
                  href={siteInfo.waiver}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Sign the waiver
                </a>
              )}
            </div>
          </details>
        ))}
      </div>
    </div>
  );
}
